// =============================================
// COMPONENTE: WebhookNode - Nó de Webhook
// =============================================
// Arquivo: WebhookNode.tsx
// Descrição: Nó para fazer chamadas HTTP/API externa
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Cloud, Link } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const WebhookNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, url, method = 'GET', description, actions } = data;

  return (
    <div className={`flow-node webhook-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header webhook-header">
        <Cloud className="node-icon" size={18} />
        <span className="node-title">{label || 'Webhook/API'}</span>
      </div>

      <div className="node-body">
        {url && (
          <div className="node-detail">
            <Link size={14} />
            <span className="node-detail-text">{method} {url}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default WebhookNode;
